import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { WizardNavGroup } from '../models/wizard/wizard-nav-group.model';
import { getNavGroupTitle } from '../models/wizard/nav-group-utils';

@Pipe({
  name: 'localizeNavGroupTitle',
  pure: false,
  standalone: false,
})
export class LocalizeNavGroupTitlePipe implements PipeTransform {
  constructor(private readonly _translocoService: TranslocoService) {}

  transform(navGroup: WizardNavGroup | undefined | null): string {
    const lang = this._translocoService.getActiveLang();
    const value = getNavGroupTitle(navGroup, lang);
    // If the resolved value is itself a Transloco key (legacy in-code default
    // like "wizard.nav.myInfo"), look it up silently without firing the
    // missing-handler on plain display strings.
    if (value) {
      const translations = this._translocoService.getTranslation(lang);
      if (translations && (translations as Record<string, string>)[value] !== undefined) {
        return this._translocoService.translate(value);
      }
    }
    return value;
  }
}
